import { useMemo, useState } from 'react';

import { Box, Row } from '@opendoor/atoms/box';
import { Button } from '@opendoor/atoms/button';
import { Loader } from '@opendoor/atoms/loader';
import type { MarketplacePropertyListFragment } from '__generated__/athena/graphql';
import { ListingCard } from 'components/marketplace/property';

interface PropertyListProps {
  isLoading: boolean;
  handleOnSeeMore: () => void;
  propertyListData: MarketplacePropertyListFragment | null;
}

export const PropertyList = ({
  isLoading,
  handleOnSeeMore,
  propertyListData,
}: PropertyListProps) => {
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const propertyCards = useMemo(() => {
    return propertyListData?.results?.map((listing: any, index: number) => {
      return (
        <Box key={index}>
          <ListingCard listing={listing} />
        </Box>
      );
    });
  }, [propertyListData]);

  const onSeeMore = async () => {
    setIsLoadingMore(true);
    await handleOnSeeMore();
    setTimeout(() => setIsLoadingMore(false), 500);
  };

  return (
    <>
      {isLoading ? (
        <Row className="w-full items-center justify-center">
          <Loader size="lg" />
        </Row>
      ) : (
        <Box className="grid grid-cols-1 gap-6 lg:grid-cols-2">{propertyCards}</Box>
      )}
      {propertyListData?.nextPage && (
        <Box className="pb-8">
          <Button
            analyticsName="more-property-list"
            aria-label="Show more"
            onClick={onSeeMore}
            variant="secondary"
            loading={isLoadingMore}
            className="w-full"
          >
            Show more
          </Button>
        </Box>
      )}
    </>
  );
};
